import { makeStyles, Tab, TabList } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import HUDMainPanel_Stats from "./HUDMainPanel_Stats";
import HUDMainPanel_CharacterSheet from "./HUDMainPanel_CharacterSheet";

const useStyles = makeStyles({
    root: {
        marginTop: "2rem",
        display: "flex",
        gap: "2rem",
        flex: "1 1 auto"
    }
});

export default function HUDMainPanel() {
    const styles = useStyles();
    const [ selectedNav, setSelectedNav ] = useState<string>( "stats" );

    useEffect(
        () => {
            if( window.location.hash ) {
                const hash = window.location.hash.substring( 1 );
                const validHashes = [ "stats", "character-sheet" ];
                if( validHashes.includes( hash ) ) {
                    setSelectedNav( hash );
                }
            }
        },
        []
    );

    return (
        <div className={styles.root}>
            <TabList vertical appearance="subtle" selectedValue={selectedNav} onTabSelect={(_, data) => setSelectedNav( data.value as string )}>
                <Tab value="stats">My Stats</Tab>
                <Tab value="character-sheet">Character Sheet</Tab>
            </TabList>

            {
                selectedNav === "stats" ? <HUDMainPanel_Stats /> :
                selectedNav === "character-sheet" ? <HUDMainPanel_CharacterSheet /> : null
            }
        </div>
    );
}